import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

interface GetExpectationForm {
  search: string;
  year: string;
  page: number;
  size: number;
}

export const getExpectationForm = ({
  search,
  year,
  page,
  size
}: GetExpectationForm) => {
  return HttpService.get(
    `${ApiService.icdc.module.expectationForm.getList}?search=${search}&tahun=${year}&page=${page}`
  );
};

export const getExpectationFormDetail = (id: string) => {
  return HttpService.get(
    `${ApiService.icdc.module.expectationForm.detail}?insertid=${id}`
  );
};

export const postExpectationForm = (data) => {
  return HttpService.post(ApiService.icdc.module.expectationForm.add, data);
};

export const updateExpectationForm = (data) => {
  return HttpService.post(ApiService.icdc.module.expectationForm.update, data);
};

export const editExpectationForm = (data) => {
  return HttpService.post(ApiService.icdc.module.expectationForm.update, data);
};

export const deleteExpectationForm = (data) => {
  return HttpService.post(ApiService.icdc.module.expectationForm.delete, data);
};
